import { defineStore } from 'pinia'
import { actions, getters, state } from './ext/items.js'
import axios from 'axios'


export const useUsersStore = defineStore('users', {
  id: 'users',
  state: () => ({
    items: [],
    api: '/api/v1/users'
  }),
  getters: {
    ...getters
  },
  actions: {
    ...actions,
    async registerUser(payload) {
      const { data } = await axios.post(this.api, payload)
      this.itemPatchState(data)
      return data
    },
    async fetchDashboardReport(userId) {
      const { data } = await axios.get(`/api/v1/users/${userId}/dashboard-report`)
      return data
    },
    async autologinAsUser(userId) {
      const { data } = await axios.post(`/api/v1/users/${userId}/autologin-token`)
      return data.token
    },
    async resetPassword(userId) {
      const { data } = await axios.post(`/api/v1/users/${userId}/reset-password`)
      this.itemPatchState(data)
      return data
    }

  }
})
